export enum MyHistoryScreen {
  chapters,
  chapter,
  stories,
}
